var _g, _rect, _rect2, _line, _g2, _rect3, _g3, _circle, _g4, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 57,
    viewBox: "0 0 39 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4041_10479)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 41.6677,
    width: 3.83306,
    height: 9.15676,
    rx: 1.91653,
    fill: "#F7D62A"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.950277,
    y: 42.618,
    width: 1.93251,
    height: 7.25621,
    rx: 0.966254,
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.6607,
    y: 42.618,
    width: 1.93251,
    height: 7.25621,
    rx: 0.966254,
    fill: "#F7D62A",
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.9024,
    y1: 27.1873,
    x2: 19.9024,
    y2: 34.6404,
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4041_10479)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.6931,
    y: 31.0203,
    width: 9.36971,
    height: 5.53665,
    rx: 2.76832,
    fill: "#F7D62A"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6434,
    y: 31.9705,
    width: 7.46915,
    height: 3.63609,
    rx: 1.81805,
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_4041_10479)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.3781,
    cy: 24.4189,
    r: 3.40717,
    fill: "#F7D62A"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3781,
    cy: 24.4189,
    r: 2.45689,
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_4041_10479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.91675 49.4272C1.91675 40.9078 8.82309 34.0015 17.3425 34.0015H21.2015C29.7209 34.0015 36.6273 40.9078 36.6273 49.4272C36.6273 53.6095 33.2369 56.9998 29.0546 56.9998H9.48938C5.30713 56.9998 1.91675 53.6095 1.91675 49.4272Z",
    fill: "#F7D62A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86702 49.4272C2.86702 41.4326 9.34791 34.9517 17.3425 34.9517H21.2015C29.1961 34.9517 35.677 41.4326 35.677 49.4272C35.677 53.0846 32.7121 56.0496 29.0546 56.0496H9.48938C5.83195 56.0496 2.86702 53.0846 2.86702 49.4272Z",
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9251,
    cy: 42.0935,
    r: 3.73458,
    fill: "white",
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9249,
    cy: 42.0936,
    r: 2.34243,
    fill: "#313131"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0735,
    cy: 41.6677,
    r: 0.851792,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.4058,
    cy: 42.0935,
    r: 3.73458,
    fill: "white",
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.4057,
    cy: 42.0936,
    r: 2.34243,
    fill: "#313131"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5542,
    cy: 41.6677,
    r: 0.851792,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1191 49.5466C16.8227 52.8473 21.6141 52.8473 23.4241 49.5466",
    stroke: "#BAA11D",
    strokeWidth: 1.90055,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2764 23.2525L22.6677 24.1182L22.2764 23.2525ZM19.5906 24.4664L19.9819 25.3321L19.9819 25.3321L19.5906 24.4664ZM19.1323 24.4664L18.7411 25.3321L18.7411 25.3321L19.1323 24.4664ZM16.4465 23.2525L16.0553 24.1182H16.0553L16.4465 23.2525ZM22.3128 18.5652L21.699 19.2903L22.3128 18.5652ZM18.2853 19.0194C17.7607 19.0194 17.3353 19.4447 17.3353 19.9694C17.3353 20.494 17.7607 20.9194 18.2853 20.9194V19.0194ZM17.4916 21.912C18.0163 21.912 18.4416 21.4867 18.4416 20.962C18.4416 20.4373 18.0163 20.012 17.4916 20.012V21.912ZM19.4098 21.0038C18.8852 21.0038 18.4598 21.4291 18.4598 21.9538C18.4598 22.4784 18.8852 22.9038 19.4098 22.9038V21.0038ZM19.7493 7.08492C20.274 7.08492 20.6993 6.65959 20.6993 6.13492C20.6993 5.61025 20.274 5.18492 19.7493 5.18492V7.08492ZM18.8693 18.0643C18.8693 18.589 19.2947 19.0143 19.8193 19.0143C20.344 19.0143 20.7693 18.589 20.7693 18.0643H18.8693ZM19.8193 12.7768L19.8146 11.8269L19.8193 12.7768ZM19.8193 11.3928L19.8146 12.3428L19.8193 11.3928ZM19.8193 10.1479L19.8261 11.0979L19.8193 10.1479ZM19.8193 15.4059H20.7693C20.7693 14.8812 20.344 14.4559 19.8193 14.4559V15.4059ZM13.4944 7.81707C13.4944 4.57678 16.1212 1.95 19.3615 1.95V0.05C15.0719 0.05 11.5944 3.52743 11.5944 7.81707H13.4944ZM19.3615 1.95C22.6018 1.95 25.2286 4.57678 25.2286 7.81707H27.1286C27.1286 3.52743 23.6511 0.05 19.3615 0.05V1.95ZM15.9612 14.0296C15.9612 12.5633 15.1535 11.4009 14.5753 10.5078C13.9464 9.53629 13.4944 8.76983 13.4944 7.81707H11.5944C11.5944 9.40066 12.3759 10.6066 12.9804 11.5403C13.6355 12.5524 14.0612 13.2281 14.0612 14.0296H15.9612ZM25.2286 7.81707C25.2286 8.7733 24.7729 9.56213 24.1452 10.5421C23.5736 11.4345 22.7617 12.6028 22.7617 14.0296H24.6617C24.6617 13.2699 25.0833 12.6001 25.7451 11.5669C26.3508 10.6214 27.1286 9.3972 27.1286 7.81707H25.2286ZM21.8852 22.3868L19.1994 23.6007L19.9819 25.3321L22.6677 24.1182L21.8852 22.3868ZM19.5236 23.6007L16.8378 22.3868L16.0553 24.1182L18.7411 25.3321L19.5236 23.6007ZM19.1994 23.6007C19.3008 23.5549 19.4222 23.5549 19.5236 23.6007L18.7411 25.3321C19.1372 25.5111 19.5858 25.5111 19.9819 25.3321L19.1994 23.6007ZM15.0953 22.5722C15.0953 23.1838 15.4197 23.8309 16.0553 24.1182L16.8378 22.3868C16.9147 22.4215 16.9555 22.471 16.9735 22.5015C16.9915 22.5321 16.9953 22.5566 16.9953 22.5722H15.0953ZM21.7277 22.5722C21.7277 22.5566 21.7315 22.5321 21.7495 22.5015C21.7675 22.471 21.8083 22.4215 21.8852 22.3868L22.6677 24.1182C23.3033 23.8309 23.6277 23.1838 23.6277 22.5722H21.7277ZM21.6476 17.3717H17.0754V19.2717H21.6476V17.3717ZM21.6476 19.2717C21.6592 19.2717 21.6681 19.2736 21.6756 19.2764C21.6835 19.2794 21.6915 19.2839 21.699 19.2903L22.9266 17.8402C22.582 17.5484 22.1342 17.3717 21.6476 17.3717V19.2717ZM21.699 19.2903C21.7085 19.2983 21.7158 19.308 21.7205 19.318C21.7248 19.3271 21.7277 19.3378 21.7277 19.3518H23.6277C23.6277 18.7453 23.3539 18.2019 22.9266 17.8402L21.699 19.2903ZM22.7617 14.0296C22.7617 16.0997 22.2391 17.2666 21.6256 17.9093L23 19.2212C24.0617 18.1089 24.6617 16.3999 24.6617 14.0296H22.7617ZM16.9953 19.3518C16.9953 19.3378 16.9982 19.3271 17.0025 19.318C17.0072 19.3081 17.0145 19.2983 17.024 19.2903L15.7962 17.8404C15.369 18.2021 15.0953 18.7455 15.0953 19.3518H16.9953ZM17.024 19.2903C17.0315 19.2839 17.0395 19.2794 17.0474 19.2764C17.0549 19.2736 17.0638 19.2717 17.0754 19.2717V17.3717C16.5887 17.3717 16.1408 17.5485 15.7962 17.8404L17.024 19.2903ZM17.0973 17.9094C16.4839 17.2667 15.9612 16.0998 15.9612 14.0296H14.0612C14.0612 16.4 14.6613 18.109 15.7229 19.2212L17.0973 17.9094ZM21.7277 19.3518V19.9694H23.6277V19.3518H21.7277ZM22.6777 19.0194H18.2853V20.9194H22.6777V19.0194ZM16.9953 22.5722V20.962H15.0953V22.5722H16.9953ZM16.9953 20.962V19.3518H15.0953V20.962H16.9953ZM16.0453 21.912H17.4916V20.012H16.0453V21.912ZM21.7277 19.9694V21.9538H23.6277V19.9694H21.7277ZM21.7277 21.9538V22.5722H23.6277V21.9538H21.7277ZM22.6777 21.0038H19.4098V22.9038H22.6777V21.0038ZM17.5256 8.14154C17.5256 8.02786 17.6005 7.78629 18.0128 7.52561C18.4131 7.27253 19.0245 7.08492 19.7493 7.08492V5.18492C18.7213 5.18492 17.7458 5.44651 16.9975 5.91968C16.2611 6.38525 15.6256 7.147 15.6256 8.14154H17.5256ZM19.7493 14.4559C19.0245 14.4559 18.4131 14.2683 18.0128 14.0152C17.6005 13.7545 17.5256 13.5129 17.5256 13.3993H15.6256C15.6256 14.3938 16.2611 15.1555 16.9975 15.6211C17.7458 16.0943 18.7213 16.3559 19.7493 16.3559V14.4559ZM19.7493 9.71377C20.1978 9.71377 20.721 9.74787 21.1061 9.8314C21.1983 9.85141 21.2726 9.87216 21.3294 9.8919C21.3573 9.90161 21.3785 9.91019 21.3937 9.91705C21.4091 9.924 21.4158 9.92798 21.4156 9.92789C21.4154 9.92774 21.4128 9.92615 21.4083 9.92293C21.4038 9.91972 21.3969 9.91451 21.3882 9.90704C21.3713 9.89245 21.3445 9.86657 21.3158 9.82717C21.2521 9.73976 21.1974 9.60969 21.1974 9.45597H23.0974C23.0974 8.8344 22.6745 8.46883 22.3991 8.30225C22.117 8.13159 21.788 8.03514 21.5089 7.97458C20.9343 7.84993 20.2584 7.81378 19.7493 7.81378V9.71377ZM17.5256 10.7704C17.5256 10.6655 17.5852 10.4609 17.9107 10.2237L16.7917 8.68819C16.1508 9.1552 15.6256 9.86975 15.6256 10.7704H17.5256ZM17.9107 10.2237C18.3011 9.93923 18.9537 9.71377 19.7493 9.71377V7.81378C18.6297 7.81378 17.5651 8.12464 16.7917 8.68819L17.9107 10.2237ZM19.7493 9.19816C18.9537 9.19816 18.3011 8.97271 17.9107 8.68819L16.7917 10.2237C17.5651 10.7873 18.6297 11.0982 19.7493 11.0982V9.19816ZM17.9107 8.68819C17.5852 8.451 17.5256 8.2464 17.5256 8.14154H15.6256C15.6256 9.04219 16.1508 9.75673 16.7917 10.2237L17.9107 8.68819ZM17.5256 13.3993C17.5256 13.2944 17.5852 13.0898 17.9107 12.8526L16.7917 11.317C16.1508 11.7841 15.6256 12.4986 15.6256 13.3993H17.5256ZM17.9107 12.8526C18.3011 12.5681 18.9537 12.3426 19.7493 12.3426V10.4426C18.6297 10.4426 17.5651 10.7535 16.7917 11.317L17.9107 12.8526ZM19.7493 11.827C18.9537 11.827 18.3011 11.6016 17.9107 11.317L16.7917 12.8526C17.5651 13.4161 18.6297 13.727 19.7493 13.727V11.827ZM17.9107 11.317C17.5852 11.0799 17.5256 10.8753 17.5256 10.7704H15.6256C15.6256 11.671 16.1508 12.3856 16.7917 12.8526L17.9107 11.317ZM21.1974 12.0848C21.1974 11.7864 21.3962 11.6441 21.4063 11.6376C21.4115 11.6343 21.3947 11.6455 21.3438 11.6637C21.2946 11.6812 21.2279 11.7002 21.1419 11.7187C20.7791 11.7969 20.2777 11.8246 19.8146 11.8269L19.824 13.7268C20.3171 13.7244 20.9797 13.6972 21.542 13.5761C21.8157 13.5172 22.1459 13.4199 22.4299 13.2383C22.7272 13.0482 23.0974 12.6744 23.0974 12.0848H21.1974ZM19.8146 11.8269C19.7927 11.827 19.7709 11.827 19.7493 11.827V13.727C19.7739 13.727 19.7988 13.727 19.824 13.7268L19.8146 11.8269ZM19.7493 12.3426C19.7709 12.3426 19.7927 12.3427 19.8146 12.3428L19.824 10.4428C19.7988 10.4427 19.7739 10.4426 19.7493 10.4426V12.3426ZM19.8146 12.3428C20.2777 12.3451 20.7791 12.3728 21.1419 12.4509C21.2279 12.4694 21.2946 12.4885 21.3438 12.506C21.3948 12.5242 21.4115 12.5354 21.4063 12.532C21.3962 12.5256 21.1974 12.3833 21.1974 12.0848H23.0974C23.0974 11.4952 22.7272 11.1214 22.4299 10.9314C22.1459 10.7497 21.8157 10.6525 21.542 10.5935C20.9797 10.4724 20.3171 10.4452 19.824 10.4428L19.8146 12.3428ZM21.1974 9.45597C21.1974 9.30657 21.2492 9.17863 21.3116 9.0906C21.3398 9.05076 21.3666 9.02401 21.3843 9.00831C21.4019 8.99268 21.4136 8.98529 21.4152 8.98431C21.4162 8.98368 21.3951 8.99642 21.341 9.01593C21.2887 9.03475 21.2194 9.05498 21.1319 9.07481C20.7658 9.1578 20.2615 9.19476 19.8126 9.19794L19.8261 11.0979C20.3334 11.0943 20.9931 11.0545 21.552 10.9278C21.8236 10.8662 22.145 10.7684 22.421 10.5962C22.6941 10.4258 23.0974 10.0618 23.0974 9.45597H21.1974ZM19.8126 9.19794C19.7913 9.19809 19.7701 9.19816 19.7493 9.19816V11.0982C19.7746 11.0982 19.8002 11.0981 19.8261 11.0979L19.8126 9.19794ZM20.7693 18.0643V15.4059H18.8693V18.0643H20.7693ZM19.7493 16.3559H19.8193V14.4559H19.7493V16.3559Z",
    fill: "#BAA11D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4041_10479",
    x: 0,
    y: 41.6677,
    width: 3.83301,
    height: 9.15674,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.80111,
    dy: 1.42542
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4041_10479"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4041_10479",
    x: 14.6931,
    y: 31.0203,
    width: 9.36963,
    height: 5.53662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.80111,
    dy: 1.42542
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4041_10479"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4041_10479",
    x: 15.9709,
    y: 21.0117,
    width: 6.81445,
    height: 6.81445,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.80111,
    dy: 1.42542
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4041_10479"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_4041_10479",
    x: 1.91675,
    y: 34.0015,
    width: 34.7104,
    height: 22.9983,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.80111,
    dy: 1.42542
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4041_10479"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/admin_icon.14ceaa6d32af07c81b29b7316420b4ad.svg";
export { ForwardRef as ReactComponent };